import {useLoaderData} from 'react-router-dom';
import React, {useEffect} from "react";
import { useUser } from "../components/UserContext";
import { getUser, userPaid, initialiseBaseSkins } from '../Users'
// import PaymentIcon from '@mui/icons-material/Payment';

export async function loader({params}) {
    const userId = params.userId;
    const user = await getUser(userId);
    if (!user) {
        throw new Response("", {
            status: 404,
            statusText: "Not Found",
        });
    }
    return {user};
}

export default function Payment() {
    const {currentUser} = useUser();
    const {user} = useLoaderData();

    useEffect(() => { //initialize
        document.title = `subscription manager`;
        initialiseBaseSkins(currentUser.id);
    }, [currentUser.id]);

    function submit() {
        userPaid(currentUser.id);
        window.location.reload();
    }

    if (user.id === currentUser.id) return(
        <div>
            <div className="page-head">
                <div className="page-title settings-title">
                    <div className="creator-pfp">
                        {/* <PaymentIcon className="creator-default-pfp"/> */}
                        </div>
                    <h2 className="title-text">subscription</h2>
                </div>
            </div>
            {currentUser.status > 0 ? 
                <div id="payment">
                    <div id="folder-create-container">
                        <div id="skin-create">
                            <div>
                                <div>
                                    <p>if you'd like to be able to see other user's pages, search, or post more than 10 blocks, 
                                        a subscription is required. 
                                    </p>
                                    <p> willow web costs £25 / month to pay the running costs of the site. currently, the 
                                        minimum subscription is £1.50 / month, but 
                                        if you are able to pay more, this would be greatly appreciated.
                                    </p>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>to subscribe to willow web, please create a standing order of your subscription amount 
                                        to the following bank details. please set it up so that the standing order begins on the 
                                        1st of the month. this lets me only have to check up on things once a month. once you've
                                        done this, click Done! to gain full access to willow web.
                                    </p>
                                    <h3>Account Details</h3>
                                    <p>Name: Ruby Kimber <br/>
                                        Sort code: 23-01-20<br/>
                                        Account number: 62350030
                                    </p>
                                    <button id="folder-submit-button" className="settings-button" onClick={submit}>Done!</button>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>if you would like to stop being an active user, just cancel your standing order.
                                        your status as an active user will end at the beginning of the next month.
                                        you will retain access to everything you have uploaded to the site, but lose the
                                        ability to create anything else, or see anything anyone else has created on the site.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div>
                    <div id="folder-create-container">
                        <div id="skin-create">
                            <div>
                                <div>
                                    <p>Sorry, but you cannot become an active user until your account is approved. It's unlikely this will take longer than 24 hours.</p>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}